import { FC, Key } from "react";

import { Flex } from "antd";

import NewTransaction from "./NewTransaction";
import GenerateBiensOffMarketPdf from "./GenerateBiensOffMarketPdf";
import RefreshAddressBiensOffMarket from "./RefreshAddressBiensOffMarket";
import LinkButton from "./LinkButton";
import Download from "./Download";

const BiensOffMarketActions: FC<{
  selectedRowKeys: Key[];
  filters: Record<string, string[]>;
}> = ({ selectedRowKeys, filters }) => {
  return (
    <Flex gap={16}>
      <NewTransaction />
      <RefreshAddressBiensOffMarket ids={selectedRowKeys as string[]} />
      <GenerateBiensOffMarketPdf ids={selectedRowKeys as string[]} />
      <Download
        filters={filters}
        collectionId="biens_off_market"
        endpoint="https://melcarnebackend.digipulse.ch/download_data_off_market"
        filename="biens_off_market.xlsx"
      />
      <LinkButton to="/collections/biens_off_market?filter=Type_de_bien%3A%3A%3Amaison%2Cappartement&page=1&limit=50">
        Résidentiel
      </LinkButton>
      <LinkButton to="/collections/biens_off_market?filter=Type_de_bien%3A%3A%3Aimmeuble%2Cbureau%2Carcade&page=1&limit=50">
        Commercial
      </LinkButton>
    </Flex>
  );
};

export default BiensOffMarketActions; 